{
  "randevu_sonuc_tip": {
    "Baslik": "Appointment Result Types",
    "Ad": "Name",
    "Kod": "Code",
    "Hedef 1": "1st Meeting Target",
    "Hedef 2": "2nd Meeting Target",
    "Dahil": "Included",
    "Dahil Degil": "Not Included",
    "Durum": "Status",
    "Arama": "Search",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Data Yenile": "Refresh Data",
    "Ekle": "Add",
    "Filtrele": "Filter",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Vazgec": "Cancel",
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Passive",
    "ARA": "Search"
  }
}
